// Minimal, safe markdown-ish renderer for coach replies.
// Supports: ## heading, ### heading, - list, 1. ordered list, **bold**, paragraphs.

function escapeHtml(s) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function renderMarkdown(src) {
  if (!src) return "";
  const lines = src.split(/\r?\n/);
  const out = [];
  let listType = null;
  let buffer = [];

  const flushParagraph = () => {
    if (buffer.length) {
      const text = buffer.join(" ").trim();
      if (text) {
        out.push(`<p>${inline(text)}</p>`);
      }
      buffer = [];
    }
  };
  const closeList = () => {
    if (listType) {
      out.push(listType === "ul" ? "</ul>" : "</ol>");
      listType = null;
    }
  };

  const inline = (t) =>
    escapeHtml(t)
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/`(.+?)`/g, "<code>$1</code>");

  for (let raw of lines) {
    const line = raw.trimEnd();
    if (!line.trim()) {
      flushParagraph();
      closeList();
      continue;
    }
    if (/^###\s+/.test(line)) {
      flushParagraph();
      closeList();
      out.push(`<h3>${inline(line.replace(/^###\s+/, ""))}</h3>`);
      continue;
    }
    if (/^##\s+/.test(line)) {
      flushParagraph();
      closeList();
      out.push(`<h2>${inline(line.replace(/^##\s+/, ""))}</h2>`);
      continue;
    }
    if (/^#\s+/.test(line)) {
      flushParagraph();
      closeList();
      out.push(`<h2>${inline(line.replace(/^#\s+/, ""))}</h2>`);
      continue;
    }
    const ulm = line.match(/^[-*]\s+(.*)/);
    const olm = line.match(/^\d+\.\s+(.*)/);
    if (ulm) {
      flushParagraph();
      if (listType !== "ul") {
        closeList();
        out.push("<ul>");
        listType = "ul";
      }
      out.push(`<li>${inline(ulm[1])}</li>`);
      continue;
    }
    if (olm) {
      flushParagraph();
      if (listType !== "ol") {
        closeList();
        out.push("<ol>");
        listType = "ol";
      }
      out.push(`<li>${inline(olm[1])}</li>`);
      continue;
    }
    buffer.push(line);
  }
  flushParagraph();
  closeList();
  return out.join("\n");
}
